/**
 * Dev-only override for "email verified" so we can test flows without actually verifying email.
 * Stored in localStorage (JSON.stringify to match app patterns). Only active when DEBUG_enabled.
 */

const KEY = 'tm_debug_email_verified';

export const getDebugEmailVerifiedOverride = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const raw = localStorage.getItem(KEY);
    if (raw === null) return false;
    const value = JSON.parse(raw) as boolean;
    return value === true;
  } catch {
    return false;
  }
};

export const setDebugEmailVerifiedOverride = (value: boolean): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(KEY, JSON.stringify(value));
};
